import React from "react";

const Crop = (props) => {
  return (
    <svg fill={props.color} height="19px" width="15px" version="1.1" id="Layer_1" viewBox="0 0 512 512" enable-background="new 0 0 512 512">
      <path d="M47.5,280.3H1v93.1h46.5V280.3z M1,94.1h46.5V47.5h46.5V1H1V94.1z M47.5,419.9H1V513h93.1v-46.5H47.5V419.9z M373.4,1h-93.1 v46.5h93.1V1z M47.5,140.6H1v93.1h46.5V140.6z M140.6,513h93.1v-46.5h-93.1V513z M419.9,1v46.5h46.5v46.5H513V1H419.9z M140.6,47.5 h93.1V1h-93.1V47.5z M466.5,233.7H513v-93.1h-46.5V233.7z M280.3,513H513V280.3H280.3V513z"></path>
    </svg>

  );
};

export default Crop;
